module.exports = __webpack_public_path__ + "assets/icons/draft-jobs.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/sidemenu/draft-jobs.png
// module id = ./src/styles/icons/sidemenu/draft-jobs.png
// module chunks = 0